module.exports = "<p>\r\n  hotspot-help works!\r\n</p>\r\n"